<template>
  <v-container>
    <h1>Spreads</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8"
          @click="dialogAdjustSpread = true"
          class="white--text my-2 mr-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          :disabled="!permissionList.includes('read')"
        >
          {{ "Actualizar spread" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoadingTable" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="spreads" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Spread" }}</th>  
            <th class="header__title center">{{ 'Desde' }}</th>
            <th class="header__title right">{{ 'Hasta' }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ parseFloat(item.spread_percentage).toFixed(6).replace(/\.?0+$/, '') + "%" }}</td>
            <td class="table__item">{{ item.valid_from ? formatDate(item.valid_from) : "-" }}</td>
            <td class="table__item">{{ item.valid_to ? formatDate(item.valid_to) : "-" }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogAdjustSpread" v-if="dialogAdjustSpread" max-width="600px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 600px">
          <v-card-title
            class="pa-0"
            style="
              display: flex;
              text-align: center;
              justify-content: center;
            "
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Agregar spread" }}
            </span>
          </v-card-title>
          <v-card-text class="py-6 px-4">
            <v-form
              ref="spreadForm"
              v-model="spreadFormValid"
              autocomplete="off"
            >
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="spreadForm.spread"
                    :disabled="isLoading"
                    :label="'Spread (%)'"
                    style="border-radius: 10px"
                    required
                    type="number"
                    outlined
                    hide-details
                    autocomplete="off"
                    name="newUserName"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="spreadForm.sDate"
                    :label="'Fecha de inicio'"
                    :disabled="isLoading"
                    style="border-radius: 10px"
                    required
                    :min="lastSpreadDate ? lastSpreadDate.split('T')[0] : null"
                    type="date"
                    outlined
                    hide-details
                    autocomplete="off"
                    name="newUserLastname"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions
            class="mt-5"
            style="justify-content: space-evenly"
          >
            <v-btn
              elevation="4"
              class="mr-2 px-10"
              style="
                color: black;
                border-radius: 36px;
                border: 2px solid black;
                background-color: #fff;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              outlined
              :disabled="isLoading"
              @click="dialogAdjustSpread = false; spreadForm = { spread: '', sDate: '' }"
            >
              {{ "Cancelar" }}
            </v-btn>
            <v-btn
              color="black"
              elevation="4"
              class="white--text px-10"
              style="
                border-radius: 36px;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              :disabled="spreadForm.spread === '' || spreadForm.sDate === '' || isLoading"
              @click="createSpread()"
            >
              {{ "Crear" }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Spreads",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        spreads: [],
        isLoading: false,
        isLoadingTable: false,
        lastSpreadDate: null,
        dialogAdjustSpread: false,
        spreadFormValid: false,
        spreadForm: {
          spread: "",
          sDate: "",
        },
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'spreads') {
          this.getSpreads();
        }
      }
    },
    computed: {
    },
    mounted() {
      if (this.activeTab === 'spreads') {
        this.getSpreads();
      }
    },
    methods: {
      getSpreads() {
        this.isLoadingTable = true;
        this.spreads = [];

        DB.get(`${URI}/api/v1/en/administrator/spreads/${this.$route.params.sEnterpriseId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.spreads = response.data.spreads;
          this.lastSpreadDate = this.spreads.length > 0 ? this.spreads[0].valid_from : null;
          this.isLoadingTable = false;
        }).catch((error) => {
          this.isLoadingTable = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      async createSpread() {
        this.isLoading = true;
        if (!this.spreadForm.spread || !this.spreadForm.sDate) {
          this.mixError(
            "Completa todos los campos"
          );
          return;
        }
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          spread: this.spreadForm.spread,
          sDate: this.spreadForm.sDate,
        };

        DB.post(`${URI}/api/v1/en/administrator/adjustSpread`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.getSpreads();
          this.dialogAdjustSpread = false;
          this.spreadForm = {
            spread: "",
            sDate: "",
          };
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
    }
  };
</script>
<style scoped>
</style>